import { StatTable } from "components/StatsTable/StatTable";
import { StatTableColumn } from "components/StatsTable/StatTableColumn";
import { Match } from "model/Match/Match";
import { selectWithDisplay } from "./Shared";
import { useAppSelector } from "app/hooks";
import {
  calculateGslSeasonRecords,
  GslSeasonRecordWithDisplay,
} from "model/Records old/GslSeasonRecord";

interface Props {
  matchesByPlayday: Match[][];
  rosterIds: string[];
  tournamentId: string;
  primaryColor?: string;
  secondaryColor?: string;
}

export const GslSeasonTable = ({
  matchesByPlayday,
  rosterIds,
  tournamentId,
  primaryColor,
  secondaryColor,
}: Props) => {
  const records = calculateGslSeasonRecords(rosterIds, matchesByPlayday) ?? [];
  const recordsWithDisplay = useAppSelector((state) =>
    selectWithDisplay(state, records, tournamentId)
  );

  const columns: StatTableColumn<GslSeasonRecordWithDisplay>[] = [
    {
      type: "Position",
      sortable: true,
      positionGetter: (arg) => arg.record.position,
    },
    {
      type: "OrgLogoName",
      sortable: true,
      orgIdGetter: (arg) => arg.orgId,
      nameGetter: (arg) => arg.displayName,
    },
    {
      type: "Number",
      header: "Played",
      sortable: false,
      valueGetter: (arg) => arg.record.matchesPlayed,
      fractionDigits: 0,
    },
    {
      type: "Number",
      header: "Wins",
      sortable: false,
      valueGetter: (arg) => arg.record.matchesWon,
      fractionDigits: 0,
      highlight: true,
    },
    {
      type: "Number",
      header: "Maps",
      title: `Total Maps Won`,
      sortable: false,
      valueGetter: (arg) => arg.record.tracksWon,
      fractionDigits: 0,
    },
    {
      type: "Number",
      header: "Rounds",
      title: `Total Rounds Won`,
      sortable: false,
      valueGetter: (arg) => arg.record.roundsWon,
      fractionDigits: 0,
    },
  ];

  return (
    <StatTable
      thinner={true}
      stats={recordsWithDisplay}
      columns={columns}
      keyGetter={(arg) => arg.displayName}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
    />
  );
};
